import React from 'react';
import Badge from './Badge.jsx';

export function CategoryDisplay({
  icon,
  name,
  description,
  className = '',
  ...props
}) {
  return (
    <div className={`flex flex-col items-center text-center p-6 bg-surface border border-border rounded-xl shadow-sm ${className}`} {...props}>
      <div className="text-4xl mb-3">{icon}</div>
      <h4 className="font-heading text-xl font-bold text-primary mb-1">{name}</h4>
      <p className="text-text-secondary text-sm mb-2">{description}</p>
      <Badge variant="accent" size="sm">Catégorie</Badge>
    </div>
  );
}

export default CategoryDisplay;
